const users = {
    name: 'Users/UsersPage',
    path: '/users',
    icon: 'mdi-account-group',
    label: 'Users'
};

const agents = {
    name: 'Agents/AgentsPage',
    path: '/agents',
    icon: 'mdi-account-group',
    label: 'Agents'
};

const offers = {
    name: 'Offers/OffersPage',
    path: '/offers',
    icon: 'mdi-home', 
    label: 'Offers'
};

const leads = {
    name: 'Leads/LeadsPage',
    path: '/leads',
    icon: 'mdi-tag',
    label: 'Leads'
};

const widgets = {
    name: 'Widgets/WidgetsPage',
    path: '/widgets',
    icon: 'mdi-view-dashboard',
    label: 'Widgets'
};

const profile = {
    name: 'Dashboard/UserProfilePage',
    path: '/profile',
    icon: 'mdi-account',
    label: 'Profile'
};

const horizon = {
    name: 'Horizon',
    path: '/horizon',
    icon: 'mdi-sun-angle',
    label: 'Horizon',
    private: true,
    privateLabel: 'SA'
};

const pulse = {
    name: 'Pulse',
    path: '/pulse',
    icon: 'mdi-pulse',
    label: 'Pulse',
    private: true,
    privateLabel: 'SA'
};

const telescope = {
    name: 'Telescope',
    path: '/telescope',
    icon: 'mdi-telescope',
    label: 'Telescope',
    private: true,
    privateLabel: 'SA'
};

const transactions = {
    name: 'Transactions/TransactionsPage',
    path: '/transactions',
    icon: 'mdi-swap-horizontal',
    label: 'Transactions'
};

export const agent = _ => {
    return [
        offers,
        leads,
        widgets
    ];
};

export const superAdmin = _ => {
    return [
        users,
        offers,
        leads,
        agents,
        transactions,
    ];
};

export const admin = _ => {
    return [
        users,
        offers,
        leads,
        agents,
        transactions,
    ];
};

export const user = _ => {
    return [];
};

export const bottomNavRoutes = _ => {
    return [
        profile,
        horizon,
        pulse,
        telescope,
    ];
};
